/**
 * Represents the state of the application
 * - `isDebugLoggingEnabled`: Indicates if debug logging is enabled.
 * - `theme`: The current theme of the application, either 'light' or 'dark'.
 */
export interface initialAppState {
    isDebugLoggingEnabled: boolean;
    theme: 'light' | 'dark';
}

export const initialAppState: initialAppState = {
    isDebugLoggingEnabled: false,
    theme: 'light'
};